export default "__VITE_ASSET__D278x$S$__"